import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AgroDealerListComponent } from './pages/agro-dealer-list/agro-dealer-list.component';
import { ShopDetailsComponent } from './pages/shop-details/shop-details.component';
import { SuccessScreenComponent } from './pages/success-screen/success-screen.component';
import { GenerateOtpComponent } from './pages/generate-otp/generate-otp.component';
import { VerifyOtpComponent } from './pages/verify-otp/verify-otp.component';
import { CapturePhotoComponent } from './pages/capture-photo/capture-photo.component';
import { ViewDealerDetailsComponent } from './pages/view-dealer-details/view-dealer-details.component';
import { AuthGuard } from './guards/auth.guard';
import { AuthErrorComponent } from './pages/auth-error/auth-error.component';
import { ExistingDealerComponent } from './pages/existing-dealer/existing-dealer.component';
import { UnsavedChangesGuard } from './guards/unsaved-changes.guard';
import { NoInternetComponent } from './components/no-internet/no-internet.component';

const routes: Routes = [
  { path: '', canActivate: [AuthGuard], children: [] },
  { path: 'dealers', component: AgroDealerListComponent, canActivate: [AuthGuard] },
  { path: 'view-dealer-details', component: ViewDealerDetailsComponent, canActivate: [AuthGuard] },
  { path: 'dealer-details-new', component: ShopDetailsComponent, canActivate: [AuthGuard], canDeactivate: [UnsavedChangesGuard] }, // For adding new
  { path: 'success', component: SuccessScreenComponent, canActivate: [AuthGuard], canDeactivate: [UnsavedChangesGuard] },
  { path: 'add-dealer-phone', component: GenerateOtpComponent, canActivate: [AuthGuard] }, // Phone number input (Generate OTP)
  { path: 'view-existing-retailers', component: ExistingDealerComponent, canActivate: [AuthGuard] },
  { path: 'verify-otp', component: VerifyOtpComponent, canActivate: [AuthGuard] }, // OTP verification
  { path: 'capture-photo', component: CapturePhotoComponent, canActivate: [AuthGuard] }, // New photo capture screen
  { path: 'auth-error', component: AuthErrorComponent }, // A component to display authentication errors
  { path: 'no-internet', component: NoInternetComponent }, // A component to display no internet connection error
  { path: '**', redirectTo: '' }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }